<template>
	<div :class="['character-container', position]">
		<div class="character-video">
			<slot></slot>
		</div>
		<DialogueBubble class="dialogue" :show="speaking" :position="dialoguePosition">
			<CMSComponent class="wysiwyg-content" :props="{ ...$attrs }" :content="content" />
			<template v-slot:footer>
				<Button v-for="(button, index) in buttons" class="button" :key="index" :action="button.action">
					{{ button.text }}
				</Button>
			</template>
		</DialogueBubble>
	</div>
</template>

<script>
import Button from "@/components/base/Button";
import CMSComponent from "@/components/base/CMSComponent";
import DialogueBubble from "@/components/partials/DialogueBubble";
import { isOneOf } from "@/lib/validators";
import { CHARACTER_COMPONENT_POSITIONS } from "@/constants";

export default {
	name: 'Character',
	components: {
		Button,
		CMSComponent,
		DialogueBubble,
	},
	props: {
		speaking: {
			required: true,
			type: Boolean,
		},
		content: {
			required: true,
			type: String,
		},
		buttons: {
			required: false,
			type: Array,
			default: () => [],
		},
		position: {
			required: false,
			type: String,
			default: "bottom-left",
			validator: isOneOf(CHARACTER_COMPONENT_POSITIONS),
		},
	},
	computed: {
		dialoguePosition() {
			let [y, x] = this.position.split("-");
			y = y === 'top' ? 'bottom' : 'top';
			x = x === 'left' ? 'right' : 'left';
			return `${y}-${x}`;
		},
	},
};
</script>

<style lang="scss" scoped>
	.character-container {
		@include cover;
		pointer-events: none;
		z-index: $z-top;
	}

	.character-video {
		width: var(--character-width);
		position: absolute;

		.top-left & { top: 0; left: 0; transform: translateY(-10%) rotateX(180deg); }
		.top-right & { top: 0; right: 0; transform: translateY(-10%) rotateY(180deg) rotateX(180deg); }
		.bottom-left & { bottom: 0; left: 0; }
		.bottom-right & { bottom: 0; right: 0; transform: rotateY(180deg) }
	}

	.dialogue {
		position: absolute !important;
		pointer-events: all;

		.top-left & { top: var(--dialogue-offset-v); left: var(--dialogue-offset-h); }
		.top-right & { top: var(--dialogue-offset-v); right: var(--dialogue-offset-h); }
		.bottom-left & { bottom: var(--dialogue-offset-v); left: var(--dialogue-offset-h); }
		.bottom-right & { bottom: var(--dialogue-offset-v); right: var(--dialogue-offset-h); }
	}

	.wysiwyg-content {
		width: 90%;
		margin: auto;

		@include mobile { font-size: $font-size-x-sm; }
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/Character.vue